export default __webpack_public_path__ + "static/media/b.f3f7aaf6.png";